import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/apiClient'
import type { components } from '../lib/api-types'

export type GraphResponse = components['schemas']['GraphResponse']
export type GraphNodeDto = components['schemas']['GraphNode']
export type GraphEdgeDto = components['schemas']['GraphEdge']
export type Lens = components['schemas']['Lens']
export type Health = components['schemas']['Health']

/**
 * Fetches a sub-graph for a lens + scope (+ depth). Empty scope = the top level
 * (landscape for the logical lens). Drives the navigator; lazy-expand is just a
 * deeper scope, so React Query caches each level by key.
 */
export function useGraph(lens: Lens, scope: string | null, depth = 1) {
  return useQuery({
    queryKey: ['graph', lens, scope ?? '', depth],
    queryFn: async (): Promise<GraphResponse> => {
      const query = scope ? { lens, scope, depth } : { lens, depth }
      const { data, error } = await api.GET('/v1/graph', { params: { query } })
      if (error || !data) throw new Error('Failed to load graph')
      return data
    },
  })
}
